import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IEnableWorkbookAccelerationParams {
  targetIds: string[];
  scheduleId: string;
}

export class EnableWorkbookAccelerationRequest extends Request<IEnableWorkbookAccelerationParams, IResult> {
  constructor(params: IEnableWorkbookAccelerationParams) {
    super('enableWorkbookAcceleration', params);
  }
}
